import { Fragment } from 'react'
import { EmptyValuePlaceholder } from '@/components/ui'

export default ({roles}) => (Array.isArray(roles) && roles.length > 0 ? 
  (
    <div className='flex flex-col space-x-1'>
      {roles.map( (role, index) => (
        <Fragment key={index}>
          <span key={index}>{roles.length > 1 && "- "}{role}</span>
        </Fragment>
      ))}
    </div>
  ) : 
  (
    <EmptyValuePlaceholder />
  )
)